import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-radius',
  templateUrl: './radius.component.html',
  styleUrls: ['./radius.component.scss'],
})
export class RadiusComponent {
  @Input() radius: any = {
    opcao1: '',
    opcao2: '',
    name: '',
    id1: '',
    id2: '',
  };
}
